import * as RelatedObjectsSection from './RelatedObjectFields/Objects';
import * as RelatedFieldsSection from './RelatedObjectFields/Fields';

export default {
  related_object_fields: {
    second: RelatedObjectsSection,
    third: RelatedFieldsSection,
  },
};
